export default __webpack_public_path__ + "static/media/Slider-5.abdf32fe.jpg";